export async function initCsrfSession() {
  try {
    await fetch(`${process.env.NEXT_PUBLIC_BACKEND_URL}/sanctum/csrf-cookie`);
  } catch (e) {
    console.log("Could not init CSRF Session:", e);
  }
}
